export default __webpack_public_path__ + "static/media/background-1.fc3e0fde.jpg";